$('.category-slider-wrapper').slick({
  dots: true,
  infinite: false,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$(".review-slider-items").slick({
  dots: true,
  infinite: false,
  speed: 300,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ]
});

$('.product-trusted-list-wrapper').slick({
  centerMode: true,
  slidesToShow: 1,
  variableWidth: true,
  prevArrow: '<button type="button" class="slick-prev">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">' +
              '  <path d="M3.825 9.49561L9.425 15.0956L8 16.4956L0 8.49561L8 0.495605L9.425 1.89561L3.825 7.49561L16 7.49561V9.49561L3.825 9.49561Z" fill="black"/>' +
              '</svg>' +
              '</button>',
  nextArrow: '<button type="button" class="slick-next">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">' +
              '  <path d="M12.175 7.49561L6.575 1.89561L8 0.495605L16 8.49561L8 16.4956L6.575 15.0956L12.175 9.49561H0V7.49561H12.175Z" fill="black"/>' +
              '</svg>' +
              '</button>',
});

$('.our-social-list').slick({
  centerMode: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        centerMode: false,
        dots: true
      }
    }
  ]
});

$('.lp-social-list').slick({
  centerMode: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        centerMode: false,
        dots: true
      }
    }
  ]
});

document.addEventListener('product-recommendations-loaded', function(e) {
  // Check if the event was dispatched by the correct element, if necessary
  if (e.detail && e.detail.initializedElement) {
    $('.product-recommendation-list').slick({
      variableWidth: true,
      prevArrow: '<button type="button" class="slick-prev">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">' +
                    '<path d="M3.825 9.5L9.425 15.1L8 16.5L0 8.5L8 0.5L9.425 1.9L3.825 7.5L16 7.5V9.5L3.825 9.5Z" fill="currentColor"/>' +
                  '</svg>' +
                  '</button>',
      nextArrow: '<button type="button" class="slick-next">' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">' +
                    '<path d="M12.175 7L6.575 1.4L8 6.99382e-07L16 8L8 16L6.575 14.6L12.175 9L-6.11959e-07 9L-7.86805e-07 7L12.175 7Z" fill="currentColor"/>' +
                  '</svg>' +
                  '</button>',

    });
  }
});

$('.product .product__media-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.product .thumbnail-list'
});

$('.product .thumbnail-list').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.product .product__media-list',
  arrows: false,
  focusOnSelect: true
});

$('.happy-customer-reviews').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M4.76982 9.50586L10.3698 15.1059L8.94482 16.5059L0.944824 8.50586L8.94482 0.505859L10.3698 1.90586L4.76982 7.50586L16.9448 7.50586V9.50586L4.76982 9.50586Z" fill="white"/></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M12.2297 9.50586L6.62969 15.1059L8.05469 16.5059L16.0547 8.50586L8.05469 0.505859L6.62969 1.90586L12.2297 7.50586L0.0546875 7.50586V9.50586L12.2297 9.50586Z" fill="white"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerMode: true,
        variableWidth: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
      }
    }
  ]
});

$('.feature-slick-items').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  variableWidth: true,
  arrows: false,
});

$('.featured-collection-grid').slick({
  variableWidth: true,
  prevArrow: '<button type="button" class="slick-prev">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">' +
                '<path d="M3.825 9.5L9.425 15.1L8 16.5L0 8.5L8 0.5L9.425 1.9L3.825 7.5L16 7.5V9.5L3.825 9.5Z" fill="currentColor"/>' +
              '</svg>' +
              '</button>',
  nextArrow: '<button type="button" class="slick-next">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">' +
                '<path d="M12.175 7L6.575 1.4L8 6.99382e-07L16 8L8 16L6.575 14.6L12.175 9L-6.11959e-07 9L-7.86805e-07 7L12.175 7Z" fill="currentColor"/>' +
              '</svg>' +
              '</button>',
});

$(window).on('resize', function() {
  // Check if the condition matches for applying slick
  if (window.matchMedia("only screen and (max-width: 768px)").matches) {
    // Initialize slick if not already initialized
    if (!$(".blog__posts").hasClass('slick-initialized')) {
      $(".blog__posts").slick({
        variableWidth: true,
        arrows: false,
        dots: true
      });
    }
  } else {
    // Destroy slick if the screen is wider than 768px and slick is initialized
    if ($(".blog__posts").hasClass('slick-initialized')) {
      $(".blog__posts").slick('unslick');
    }
  }

  if (window.matchMedia("only screen and (max-width: 1024px)").matches) {
    // Initialize slick if not already initialized
    if (!$(".product-ingredient-list").hasClass('slick-initialized')) {
      $(".product-ingredient-list").slick({
        variableWidth: true,
        arrows: false,
        dots: true
      });
    }
  } else {
    // Destroy slick if the screen is wider than 1024px and slick is initialized
    if ($(".product-ingredient-list").hasClass('slick-initialized')) {
      $(".product-ingredient-list").slick('unslick');
    }
  }

  if (window.matchMedia("only screen and (max-width: 768px)").matches) {
    if (!$(".aboutus-image-wrapper").hasClass('slick-initialized')) {
      $(".aboutus-image-wrapper").slick({
        variableWidth: true,
        arrows: false,
        centerMode: true,
      });
    }
  } else {
    if ($(".aboutus-image-wrapper").hasClass('slick-initialized')) {
      $(".aboutus-image-wrapper").slick('unslick');
    }
  }

  if (window.matchMedia("only screen and (max-width: 749px)").matches) {
    if (!$(".happy-customer-footer").hasClass('slick-initialized')) {
      $(".happy-customer-footer").slick({
        variableWidth: true,
        arrows: false,
        centerMode: true,
      });
    }
  } else {
    if ($(".happy-customer-footer").hasClass('slick-initialized')) {
      $(".happy-customer-footer").slick('unslick');
    }
  }
}).trigger('resize');

$(".image-with-text__accordion-item .heading").on('click', function () {
  $(this).parent().toggleClass('open');
});

$(".announcement-bar-wrapper").slick({
  speed: 8000,
  autoplay: true,
  autoplaySpeed: 0,
  centerMode: false,
  cssEase: 'linear',
  slidesToShow: 1,
  draggable:false,
  focusOnSelect:false,
  pauseOnFocus:false,
  pauseOnHover:false,
  slidesToScroll: 1,
  variableWidth: true,
  infinite: true,
  initialSlide: 1,
  arrows: false,
  buttons: false
});
